import { Link } from "react-router-dom";
import { Heart, ShoppingBag } from "lucide-react";
import { useStore } from "@/context/StoreContext";
import { formatPrice, img } from "@/lib/api";
import { Button } from "@/components/ui/button";

export default function Wishlist() {
  const { wishlist, toggleWishlist, addToCart } = useStore();
  if (!wishlist.length) return (
    <div className="mx-auto max-w-2xl px-6 py-24 text-center">
      <Heart className="h-12 w-12 mx-auto text-muted-foreground" />
      <h1 className="font-display text-4xl mt-6">Your Wishlist is Empty</h1>
      <p className="text-muted-foreground mt-3">Tap the heart on any product to save it here.</p>
      <Link to="/shop"><Button className="mt-8 rounded-none bg-[#D4AF37] text-black">Browse Products</Button></Link>
    </div>
  );
  return (
    <div className="mx-auto max-w-7xl px-4 sm:px-6 py-12">
      <h1 className="font-display text-4xl mb-10">My Wishlist</h1>
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-x-5 gap-y-10">
        {wishlist.map((p) => (
          <div key={p.id} className="group" data-testid={`wishlist-item-${p.id}`}>
            <Link to={`/product/${p.slug}`} className="block aspect-[3/4] overflow-hidden bg-[#F5F1E8] dark:bg-[#141414]">
              <img src={img(p.image)} alt={p.name} className="h-full w-full object-cover group-hover:scale-105 transition-transform duration-500" />
            </Link>
            <h3 className="font-display text-lg mt-3">{p.name}</h3>
            <p className="text-muted-foreground">{formatPrice(p.price)}</p>
            <div className="flex gap-2 mt-3">
              <Button onClick={() => addToCart(p)} className="flex-1 rounded-none bg-[#D4AF37] text-black text-sm hover:brightness-110"><ShoppingBag className="h-4 w-4 mr-1" />Add</Button>
              <Button variant="outline" onClick={() => toggleWishlist(p)} className="rounded-none border-border">Remove</Button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
